import { logistica_MANIFIESTO_PROFORMA_DETALLE } from "@pcgerente-node/pcg-comun/dist/DTOs"
import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import "./styleModal.css"

interface ChildProps {
    manifiestoProformaDetalle?: logistica_MANIFIESTO_PROFORMA_DETALLE
    handleAnularResumen(id: number):  Promise<boolean>
    setMensajeAnulacion(mensaje: string): void
}


const ModalAnularManifiesto: React.FC<ChildProps> = ({manifiestoProformaDetalle, handleAnularResumen, setMensajeAnulacion}) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleClick = async () => {

        const manifiestoP = manifiestoProformaDetalle?.logistica_MANIFIESTO_PROFORMA
        if(manifiestoP?.estado === "P" && manifiestoP.id){
            await handleAnularResumen(manifiestoP.id)
        }
        else{
            setMensajeAnulacion("No se puede anular este resumen de guias porque su estado no es pendiente")
        }
        handleClose()
    }


    return (
        <>
      <button className="btn btn-danger" onClick={handleShow} id="btnAnularResumen">
        Anular Resumen
      </button>

      <Modal show={show} onHide={handleClose} animation={false} centered>
        <Modal.Body>
            <h3 className="mt-4 text-center">¿Quiere anular este Resumen de Guias?</h3>

            <div className="d-flex justify-content-around mt-4 mb-4 ml-5 mr-5">
                <button className="btn btn-primary" onClick={() => handleClose()}>Cancelar</button>
                <button className="btn btn-danger" onClick={() => handleClick()}>Anular Resumen</button>
            </div>
        </Modal.Body>
      </Modal>
    </>
    )
}




export default ModalAnularManifiesto